<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <exporter grid-ref="theGrid" :url="'stars/exportsellinobjectives'">
        </exporter>
        <router-link class="btn btn-primary" :to="{ name: 'sellin_objectives.import' }"><i class="fa fa-plus"></i>
          Importar</router-link>
        <router-link class="btn btn-primary" :to="{ name: 'sellin_objectives.create' }"><i class="fa fa-plus"></i>
          Criar</router-link>
      </div>
      <grid-filters grid-data="theGrid" :fields="gridFilters"></grid-filters>
      <Grid ref="theGrid" name="sellinObjectivesGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns"
        :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'sellinObjectivesGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }, 'updated_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      preload: [],
      url: 'stars/sellin_objectives',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'stars_st_code',
        title: 'ST',
        width: '120px'
      },
      {
        field: 'stars_cha_code',
        title: 'CHA',
        width: '120px'
      },
      {
        field: 'obj_top10',
        title: 'Top10',
        width: '120px'
      },
      {
        field: 'obj_usg_ufs',
        title: 'USG UFS',
        width: '120px'
      },
      {
        field: 'obj_usg_spreads',
        title: 'USG Spreads',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function (element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      },
      {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function (element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: 'sellin_objectives.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('sellin_objectives.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
